export const MELTING_TEMP_DEFAULT_ERROR_STATE = {
  dnaConc: false,
  monovalentConc: false,
  divalentConc: false,
  dntpConc: false,
};
